// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"532":"3f30608c3981fa2a3e0b","678":"4821740162ea472aa84c","883":"8b20a9c3caa32ab46f0b"}[chunkId] + ".js";
};